module.exports = __webpack_public_path__ + "static/media/kwik-leasing-offers.892de32a.png";